import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;

export const fetchServices = async (token, veterinaryId) => {
  const response = await axios.get(`${apiUrl}/api/v1/services`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { veterinary_id: veterinaryId },
  });
  return response.data;
};

export const createService = async (token, serviceData) => {
  const response = await axios.post(
    `${apiUrl}/api/v1/services`,
    { service: serviceData },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

export const updateService = async (token, serviceId, serviceData) => {
  const response = await axios.put(
    `${apiUrl}/api/v1/services/${serviceId}`,
    { service: serviceData },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

export const deleteService = async (token, serviceId) => {
  await axios.delete(`${apiUrl}/api/v1/services/${serviceId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
